"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function Verified(props) {
  return _react2["default"].createElement(
    "svg",
    { className: props.className, width: props.size, viewBox: "0 0 10 10" },
    _react2["default"].createElement(
      "g",
      { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
      _react2["default"].createElement("path", {
        d: "M2.06189125,8.1815612 L0.132884003,4.47985733 C0.012169871,4.26677489 -0.0277242581,4.01536305 0.0190481691,3.75632166 C0.121190896,3.19118998 0.639470659,2.81897692 1.17443029,2.92688056 C1.3279883,2.95776207 1.47294843,3.02788127 1.60587154,3.13487663 L3.34469385,5.16044099 L8.34177743,0.26408634 L8.35140704,0.255911822 C8.59696229,0.042829385 8.89737196,-0.0412773228 9.1970938,0.0190324547 C9.73222539,0.126936093 10.0843943,0.674447146 9.98242348,1.23957883 C9.95129918,1.41160702 9.87907705,1.57146426 9.77349518,1.70189324 L4.62336947,8.3964602 C4.25727205,8.86513257 3.68121458,9.08402799 3.11788197,8.97049302 C2.66976085,8.88021001 2.28474811,8.59264863 2.06189125,8.1815612 Z",
        fill: "#FF6600"
      })
    )
  );
}

exports["default"] = Verified;
module.exports = exports["default"];